// SamplingGroup.js
// This will contain the SamplingGroup class and the class to hold the SamplingGroupEmployees and SamplingGroupWells.

import { GroupFieldNotes } from "./FieldNotes";

// SamplingGroupEmployees class
export class SamplingGroupEmployees {
  constructor(data) {
    this.id = data.id || crypto.randomUUID();
    this.samplingGroupId = data.sampling_group_id;
    this.employeeId = data.employee_id || null;
    this.employeeName = data.employee_name || "";
    this.employeeLabel = data?.employee_id
      ? {
          id: data.employee_id,
          name: data.employee_name,
        }
      : null;
    // Field notes associated with this employee
    this.fieldNotes = data.field_notes || [];
  }

  setEmployee(employee) {
    if (!employee) {
      this.employeeId = null;
      this.employeeName = "";
      this.employeeLabel = null;
      return;
    }
    this.employeeId = employee.id;
    this.employeeName = employee.name;
    this.employeeLabel = employee?.id
      ? {
          id: employee.id,
          name: employee.name,
        }
      : null;
  }

  toJson() {
    return {
      id: this.id,
      sampling_group_id: this.samplingGroupId,
      employee_id: this.employeeId,
      employee_name: this.employeeName,
      field_notes: this.fieldNotes, // I can't remember if this matters or not...
    };
  }
}

// SamplingGroupWells class
export class SamplingGroupWells {
  constructor(data) {
    this.id = data.id || crypto.randomUUID();
    this.samplingGroupId = data.sampling_group_id;
    this.wellId = data.well_id;
    this.wellName = data.well_name || data.site_name || "";
    this.wellLabel = data?.well_id
      ? {
          id: data.well_id,
          name: data.well_name || data.site_name || "",
        }
      : null;
    this.samplingSiteName = data.sampling_site_name;
  }

  setSamplingSiteName(samplingSiteName) {
    this.samplingSiteName = samplingSiteName;
  }

  setWell(well) {
    if (!well) {
      this.wellId = null;
      this.wellName = "";
      this.wellLabel = null;
      return;
    }
    this.wellId = well.id;
    this.wellName = well.name;
    this.wellLabel = well?.id
      ? {
          id: well.id,
          name: well.name,
        }
      : null;
  }

  toJson() {
    return {
      id: this.id,
      sampling_group_id: this.samplingGroupId,
      well_id: this.wellId,
      well_name: this.wellName,
      sampling_site_name: this.samplingSiteName,
    };
  }
}

// SamplingGroup class
export class SamplingGroup {
  constructor(data = {}) {
    this.id = data.id || crypto.randomUUID();
    this.samplingGroupId = data.sampling_group_id || this.id;
    this.groupName = data.group_name || "";

    // Employees in this group
    this.employees = data.employees
      ? data.employees.map((employee) => new SamplingGroupEmployees(employee))
      : [];

    // Wells assigned to this group
    this.wells = data.wells
      ? data.wells.map((well) => new SamplingGroupWells(well))
      : [];

    // // Field notes for this group
    // this.fieldNotes = data.field_notes
    //   ? data.field_notes.map((fieldNote) => new GroupFieldNotes(fieldNote))
    //   : [];
  }

  addNewBlankEmployee() {
    this.employees.push(new SamplingGroupEmployees({}));
  }

  addNewBlankWell() {
    this.wells.push(new SamplingGroupWells({}));
  }

  removeEmployee(employeeId) {
    this.employees = this.employees.filter(
      (employee) => employee.id !== employeeId
    );
  }

  removeWell(wellId) {
    this.wells = this.wells.filter((well) => well.id !== wellId);
  }

  // // Field notes methods
  // addNewBlankFieldNote() {
  //   this.fieldNotes.push(
  //     new GroupFieldNotes({
  //       sampling_group_id: this.samplingGroupId,
  //       group_field_notes_order: this.fieldNotes.length,
  //     })
  //   );
  // }

  // removeFieldNote(fieldNoteId) {
  //   this.fieldNotes = this.fieldNotes.filter(
  //     (fieldNote) => fieldNote.id !== fieldNoteId
  //   );
  //   // Update field note order after removal
  //   this.fieldNotes.forEach((fieldNote, index) => {
  //     fieldNote.groupFieldNotesOrder = index;
  //   });
  // }

  // updateFieldNoteWeatherDescription(fieldNoteId, weatherDescription) {
  //   const fieldNote = this.fieldNotes.find(
  //     (fieldNote) => fieldNote.id === fieldNoteId
  //   );
  //   if (fieldNote) {
  //     fieldNote.setWeatherDescription(weatherDescription);
  //   }
  // }

  // updateFieldNoteDate(fieldNoteId, date) {
  //   const fieldNote = this.fieldNotes.find(
  //     (fieldNote) => fieldNote.id === fieldNoteId
  //   );
  //   if (fieldNote) {
  //     fieldNote.setDate(date);
  //   }
  // }

  toJson() {
    return {
      sampling_group_id: this.samplingGroupId,
      group_name: this.groupName,
      employees: this.employees.map((employee) => employee.toJson()),
      wells: this.wells.map((well) => well.toJson()),
      // field_notes: this.fieldNotes.map((fieldNote) => fieldNote.toJson()),
    };
  }
}
